import dayjs from "./dayjs"
import { v1 as uuidv1 } from "uuid"

export const getParamFromQueryString = (name: string) => {
  const url = globalThis.location.href
  name = name.replaceAll(/[[\]]/g, String.raw`\$&`)

  const regex = new RegExp("[?#&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url)

  if (!results) return null
  if (!results[2]) return null

  return decodeURIComponent(results[2].replaceAll("+", " "))
}

export const isValidToken = () => {
  const token = sessionStorage.getItem("access_token")
  const now = dayjs()
  const created = sessionStorage.getItem("created_at")
  const expire = dayjs(created).add(
    Number(sessionStorage.getItem("expires_in")),
    "s",
  )

  return now.isBefore(expire) && !!token
}

export class RequestHeader {
  public id: string
  public businessFlowId: Array<string>
  public sentAt: string

  constructor(id?: string, businessFlowId?: Array<string>, sentAt?: string) {
    this.id = id || uuidv1()
    this.businessFlowId = businessFlowId || []
    this.sentAt = sentAt || new Date().toISOString()
  }
}
